/**
 * Границы непрозрачной части картинки в RGBA-массиве
 * @param {Uint8Array|Uint8ClampedArray} data
 * @param {number} width
 * @param {number} height
 * @returns {{x: number, y: number, width: number, height: number}|null} null — картинка пуста
 */
export const findContentBounds = (data, width, height) => {
  let minX = width;
  let maxX = -1;
  let minY = height;
  let maxY = -1;
  for (let y = 0; y < height; y += 1) {
    for (let x = 0; x < width; x += 1) {
      if (data[(y * width + x) * 4 + 3] > 0) {
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
        if (y < minY) minY = y;
        maxY = y;
      }
    }
  }
  return maxX < 0 ? null : {x: minX, y: minY, width: maxX - minX + 1, height: maxY - minY + 1};
};

/**
 * Вырезать из RGBA-массива часть по границам
 * @returns {Uint8Array}
 */
export const cropPixels = (data, width, {x, y, width: cropWidth, height: cropHeight}) => {
  const cropped = new Uint8Array(cropWidth * cropHeight * 4);
  for (let row = 0; row < cropHeight; row += 1) {
    const start = ((y + row) * width + x) * 4;
    cropped.set(data.subarray(start, start + cropWidth * 4), row * cropWidth * 4);
  }
  return cropped;
};

/**
 * Кадр рисует только непрозрачную часть картинки, а спрайт ведет себя как прежде: размер,
 * масштаб и центр считаются от полной картинки (обычная обрезка кадра в Phaser). Прозрачное
 * поле больших картинок на поле иначе закрашивается зря: на телефоне закраска дорогая.
 *
 * Для картинок из файла: читает ее один раз, поэтому зовется при старте сцены
 *
 * @param {Phaser.Scene} scene
 * @param {string} textureKey
 */
export const trimTextureFrame = (scene, textureKey) => {
  if (!scene.textures?.exists?.(textureKey) || typeof document === 'undefined') {
    return;
  }
  const texture = scene.textures.get(textureKey);
  const frame = texture.get();
  const image = texture.getSourceImage();
  if (frame.trimmed || !image?.width) {
    return;
  }
  const {width, height} = image;
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext('2d', {willReadFrequently: true});
  if (!context) {
    return;
  }
  context.drawImage(image, 0, 0);
  const bounds = findContentBounds(context.getImageData(0, 0, width, height).data, width, height);
  if (!bounds) {
    return;
  }
  frame.setCutPosition(bounds.x, bounds.y);
  frame.setCutSize(bounds.width, bounds.height);
  frame.setTrim(width, height, bounds.x, bounds.y, bounds.width, bounds.height);
};
